// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"04d02039","287":"0e30c137","712":"4a7806dd","768":"54c372bf","857":"855766af"}[chunkId] + ".chunk.js";
};